import React, { Component } from 'react'

export class Header extends Component {
    
    render() {
        return (
                <div style={{backgroundColor: 'darksalmon' }}>
                    <h1 style={{padding: '0.25em'}}>Stamp Collector</h1>
                </div>
        )
    }
}

export default Header
